import { render, staticRenderFns } from "./DocumentosVirtualizacao.vue?vue&type=template&id=d3c11ab4"
import script from "./DocumentosVirtualizacao.vue?vue&type=script&lang=js"
export * from "./DocumentosVirtualizacao.vue?vue&type=script&lang=js"
import style0 from "./DocumentosVirtualizacao.vue?vue&type=style&index=0&id=d3c11ab4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports